// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodBenchmarkId } from './FoodBenchmark';
import { foodNutrientTypeId } from './FoodNutrientType';
import { z } from 'zod';
export const foodBenchmarkNutritionalEntryId = (z.number());
export const foodBenchmarkNutritionalEntry = z.object({
    id: foodBenchmarkNutritionalEntryId,
    benchmark_id: foodBenchmarkId,
    nutrient_type_id: foodNutrientTypeId,
    value: z.number().nullable(),
    unit: z.string().nullable(),
    display_order: z.number(),
    created_at: z.date().nullable(),
});
export const foodBenchmarkNutritionalEntryInitializer = z.object({
    id: foodBenchmarkNutritionalEntryId.optional(),
    benchmark_id: foodBenchmarkId,
    nutrient_type_id: foodNutrientTypeId,
    value: z.number().optional().nullable(),
    unit: z.string().optional().nullable(),
    display_order: z.number().optional(),
    created_at: z.date().optional().nullable(),
});
export const foodBenchmarkNutritionalEntryMutator = z.object({
    id: foodBenchmarkNutritionalEntryId.optional(),
    benchmark_id: foodBenchmarkId.optional(),
    nutrient_type_id: foodNutrientTypeId.optional(),
    value: z.number().optional().nullable(),
    unit: z.string().optional().nullable(),
    display_order: z.number().optional(),
    created_at: z.date().optional().nullable(),
});
//# sourceMappingURL=FoodBenchmarkNutritionalEntry.js.map